const items = value => Array.isArray(value) ? value.filter(item => item
    && typeof item.title === 'string' && typeof item.text === 'string') : []

export function normalizeInspectionHints(value) {
    if (Array.isArray(value)) return { legacy: true, attention: items(value), history: [], context: null }
    if (value?.version !== 2) return null
    return { legacy: false, attention: items(value.attention),
        history: items(value.history).filter(item => item.evidence && typeof item.evidence === 'object'),
        context: value.context || {} }
}
